import type { DayNightPhase } from "../../models/dayNightPhase.ts";
import type { Season } from "../../models/season.ts";
import type { TileTerrain } from "../../models/worldState.ts";
import { unitFromSeed } from "./turnSeed.ts";
import {
  SEASON_PHASE_TEMP_BANDS,
  TERRAIN_TEMPERATURE_DELTA,
} from "./weatherConfig.ts";

function temperatureSeed(turn: number, terrain: TileTerrain): number {
  let seed = turn * 1_009;
  for (const char of terrain) {
    seed = Math.imul(seed, 31) + char.charCodeAt(0);
  }
  return seed;
}

export function resolveTemperature(
  turn: number,
  terrain: TileTerrain,
  season: Season,
  dayNightPhase: DayNightPhase,
  cycleProgress: number,
): number {
  const band = SEASON_PHASE_TEMP_BANDS[season][dayNightPhase];
  const delta = TERRAIN_TEMPERATURE_DELTA[terrain];
  const min = band.min + delta;
  const max = band.max + delta;
  const jitter = unitFromSeed(temperatureSeed(turn, terrain));
  const blend = cycleProgress * 0.4 + jitter * 0.6;
  return Math.round(min + (max - min) * blend);
}
